import { useContext } from 'react';
import { CoinGeckoContext } from '../providers/CoinGeckoProvider';

export function useCoinGecko() {
  const context = useContext(CoinGeckoContext);
  if (!context) {
    throw new Error('useCoinGecko must be used inside CoinGeckoProvider');
  }
  return context;
}

export default useCoinGecko;
